import { render, staticRenderFns } from "./site-back-button.vue?vue&type=template&id=26914358&scoped=true&"
import script from "./site-back-button.vue?vue&type=script&lang=js&"
export * from "./site-back-button.vue?vue&type=script&lang=js&"
import style0 from "./site-back-button.vue?vue&type=style&index=0&id=26914358&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26914358",
  null
  
)

export default component.exports